export const update = {
  updateSuccessfully: '社員情報を保存しました。',
}
